<template>
  <div :id="id" v-show="showError === true">
    <div class="tw-rounded-md tw-bg-red-50 tw-py-2.5 tw-px-4 sm:tw-py-4 sm:px-6">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex">
          <div class="tw-flex tw-items-center">
            <alert-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
          </div>
          <div class="tw-ml-4 tw-text-red-600">
            <div class="tw-font-xl">{{ title }}</div>
            <div class="tw-font-thin tw-text-sm tw-text-red-500">{{ message }}</div>
            <div id="inlineErrorDetails">
              <ul class="tw-text-xs tw-font-thin tw-text-red-500">
                <li>{{ detailedErrorMessage }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tw-flex tw-items-center tw-ml-4">
          <base-icon type="icon" color="red" @click="showError = false">
            <x-icon class="tw-h-6 tw-w-6 tw-text-red-600 tw-cursor-pointer" aria-label="Dismiss" />
          </base-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertIcon from "@/assets/svgs/alert-icon.svg";
import XIcon from "@/assets/svgs/x-icon.svg";
import errormessage from "@/mixins/errormessage";

export default {
  components: {
    AlertIcon,
    XIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Error With this action",
    },
    message: {
      type: String,
      default: "There was an error with this action. please try again.",
    },
    error: {
      type: [Object, Error],
    },
  },
  data() {
    return {
      showError: false,
    };
  },
  computed: {
    detailedErrorMessage() {
      return this.error ? this.getErrorMessage(this.error) : "No Details Available :(";
    },
  },
  mixins: [errormessage],
  watch: {
    title(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.showError = false;
      } else {
        this.showError = true;
      }
    },
    message(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.showError = false;
      } else {
        this.showError = true;
      }
    },
    error(newValue) {
      this.showError = true;
      if (newValue) throw newValue;
    },
  },
};
</script>
